<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="组织列表" name="1">
      <OrganiseAdd :updataID='updataID'></OrganiseAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 大会议程修改
 */
import OrganiseAdd from '../../../../static/form/OrganiseAdd.vue'
export default {
  components: {
    OrganiseAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Organisegl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/OrganiseUpdate.vue